<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row gutters">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h5 v-if="status">New SAP Equipment</h5>
                            <h5 v-else>Update SAP Equipment</h5>
                        </div>
                        <div class="card-body">
                            <div class="row gutters">
                                <div class="col-sm-4">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Equipment Code *</div>
                                        <input class="form-control" v-model="sap_equipment.equipment_code" :class="{'is-invalid': errors.equipment_code}" ref="equipment_code" type="text" placeholder="Enter Equipment Code" />
                                        <span v-if="errors.equipment_code" class="invalid-feedback">{{ errors.equipment_code[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Equipment Desc *</div>
                                        <input class="form-control" v-model="sap_equipment.equipment_desc" :class="{'is-invalid': errors.equipment_desc}" type="text" placeholder="Enter Equipment Desc" />
                                        <span v-if="errors.equipment_desc" class="invalid-feedback">{{ errors.equipment_desc[0] }}</span>
                                    </div>
                                </div>
                                 <div class="col-sm-4">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Latitude *</div>
                                        <input class="form-control" v-model="sap_equipment.latitude" :class="{'is-invalid': errors.latitude}" type="text" placeholder="Enter Latitude" />
                                        <span v-if="errors.latitude" class="invalid-feedback">{{ errors.latitude[0] }}</span>
                                    </div>
                                </div>
                                 <div class="col-sm-4">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Longitude *</div>
                                        <input class="form-control" v-model="sap_equipment.longitude" :class="{'is-invalid': errors.longitude}" type="text" placeholder="Enter Longitude" />
                                        <span v-if="errors.longitude" class="invalid-feedback">{{ errors.longitude[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Radius *</div>
                                        <input class="form-control" v-model="sap_equipment.radius" :class="{'is-invalid': errors.radius}" type="text" placeholder="Enter Radius" />
                                        <span v-if="errors.radius" class="invalid-feedback">{{ errors.radius[0] }}</span>
                                    </div>
                                </div>
                                
                                
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end">
                                    <router-link :to="{ name: 'SAPEquipment.Index' }" class="btn btn-danger">Discard </router-link>
                                    <button type="button" class="btn btn-primary ms-1" v-if="status" @click="addSAPEquipment">Submit</button>
                                    <button type="button" class="btn btn-primary ms-1" v-else @click="updateSAPEquipment">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            status: true,
            sap_equipment: {
                sap_equipment_id: "",
                equipment_code: "",
                equipment_desc: "",
                latitude: "",
                longitude: "",
                radius: "",
            },
            errors: {},
        };
    },

    mounted() {
        if (this.$route.params.sap_equipment_id) {
            this.status = false;
            this.loadSAPEquipment();
        }
    },

    methods: {
        loadSAPEquipment() {
            let loader = this.$loading.show();
            this.$store.dispatch("post", {
                uri: "viewSAPEquipment/" + this.$route.params.sap_equipment_id
            })
            .then((res) => {
                this.sap_equipment = res.data.data;
                loader.hide();
            })
            .catch((err) => {
                loader.hide();
                this.errors = err.response?.data?.errors || {};
            });
        },

        addSAPEquipment() {
            let loader = this.$loading.show();
            this.$store.dispatch("post", {
                uri: "addSAPEquipment",
                data: this.sap_equipment
            })
            .then(() => {
                loader.hide();
                this.$router.push({ name: "SAPEquipment.Index" });
            })
            .catch((err) => {
                loader.hide();
                this.errors = err.response.data.errors || {};
            });
        },

        updateSAPEquipment() {
            let loader = this.$loading.show();
            this.$store.dispatch("post", {
                uri: "updateSAPEquipment/" + this.sap_equipment.sap_equipment_id,
                data: this.sap_equipment
            })
            .then(() => {
                loader.hide();
                this.$router.push({ name: "SAPEquipment.Index" });
            })
            .catch((err) => {
                loader.hide();
                this.errors = err.response.data.errors || {};
            });
        },
    }
};
</script>
<style>

</style>
